// extracted by mini-css-extract-plugin
export default {"container":"_3aODvzcX","mainImage":"XXRV0z0s","thumbnail":"_1B4P-g2K","button":"_2YzEnYTj","buttonRight":"_3xcbCO1e"};